import { Locale } from "date-fns";
import { arSA, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { DateView } from "@mui/x-date-pickers/models";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { CalendarInputIcon } from "../../assets/icons/MUI/components";

const localeMap: Record<string, Locale> = {
  ar: arSA,
  "ar-SA": arSA,
  en: enUS,
  "en-US": enUS,
};
const defaultLocale = enUS;

const DateField = ({
  placeholder,
  label,
  value,
  onChange,
  views,
  error,
  ...props
}: {
  placeholder?: string;
  label?: string;
  value?: Date | null;
  onChange?: (date: Date | null) => void;
  views?: readonly DateView[];
  error?: boolean;
} & Omit<DatePickerProps<any>, "onChange" | "value">) => {
  const { i18n } = useTranslation();
  const locale = localeMap[i18n.language] ?? defaultLocale;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        views={views ?? ["year", "month", "day"]}
        slotProps={{
          textField: {
            placeholder: placeholder,
            error: error,
          },
        }}
        slots={{
          openPickerIcon: CalendarInputIcon,
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default DateField;
